export function addScrolledClass() {
    const body = document.body;
    let isScrolled = false;
    let isHovered = false;

    function updateScrolledClass() {
        if (isScrolled || isHovered) {
            body.classList.add('scrolled');
        } else {
            body.classList.remove('scrolled');
        }
    }

    window.addEventListener('scroll', () => {
        isScrolled = window.scrollY > 0;
        updateScrolledClass();
    });

    const navLists = document.querySelectorAll('.site-navigation__list');

    navLists.forEach((navList) => {
        navList.addEventListener('mouseenter', () => {
            isHovered = true;
            updateScrolledClass();
        });

        navList.addEventListener('mouseleave', () => {
            isHovered = false;
            updateScrolledClass();
        });
    });
}
